import React, {Component} from "react";
import {observer} from "mobx-react";
import NoData from "../noData";
import {Button} from "antd";
import "./index.less";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {RightCircleFilled} from "@ant-design/icons";
import {IMythServerResponse, IPInfluence} from "../../bean/ResponseBean";
import {isEmpty, MythServerResultCode} from "../../constant/CommonConstant";
import logger from "../../logger";
import {Web3Store} from "../../stores/web3Store";
import {getRoutePath, MythRouteId} from "../../router-config";
import owner from "../../images/icons/owner.png";

interface IProps extends RouteComponentProps {
    web3Store: Web3Store,
    licensedNFTId: number
}

interface IStates {
    list: IPInfluence[]
}


@observer
class IPInfluenceList extends Component<IProps, IStates> {

    constructor(props: IProps, state: IStates) {
        super(props, state);
        this.state = {
            list: []
        };
    }

    onClickIPItem = (url: string) => {
        if(!isEmpty(url)) {
            window.open(url)
        }
    };

    onClickOwner = (url: string) => {
        if(!isEmpty(url)){
            window.open(url)
        }
    };

    onClickBrand = (brandId: number) => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.BrandInfo),
            state: {brandId: brandId}
        });
    };

    componentDidMount(): void {
        this.getIPInfluences();
    }

    getIPInfluences = async () => {
        const {web3Store, licensedNFTId} = this.props;
        try {
            if (web3Store.mythServerApi) {
                const result: IMythServerResponse<IPInfluence[]> = await web3Store.mythServerApi.getIPInfluences(licensedNFTId);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.setState({
                            list: data
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    render() {
        const {list} = this.state;
        return <>
            {list && list.length > 0 ? <div className="influence-list flex-row">
                {list.map((item, i) => (
                    <div className="list-item" key={i} onClick={event => {
                        this.onClickIPItem(item.url)
                    }}>
                        <div className="img-container">
                            <img className="item-img" src={item.image} alt=""/>
                        </div>
                        <div className="item-info flex-row">
                            {
                                item.exhibitionFlag ?
                                    <Button className="influence-button"><i className="iconfont icon-kanzhanlan"></i>
                                        Gallary</Button> : ""
                            }
                            {
                                item.ownerFlag ? <Button className="influence-button" onClick={event => {
                                    this.onClickOwner(item.ownerUrl);
                                    event.stopPropagation();
                                }
                                }><img src={owner} alt="" className="icon-owner" />Influcencers'HODL</Button> : ""
                            }
                            {
                                item.brandId > 0 ? <Button className="influence-button" onClick={event => {
                                    this.onClickBrand(item.brandId);
                                    event.stopPropagation();
                                }
                                }><i className="iconfont icon-pinpaiguanli"></i>Brand licensing</Button> : ""
                            }
                        </div>
                        <div className="item-desc">{item.description}{isEmpty(item.url)?"":<RightCircleFilled className="arrow"/>}</div>
                    </div>
                ))}
            </div> : <NoData/>}
        </>
    }
}

export default withRouter(IPInfluenceList);
